export const strings = {
    prefixAgo: null,
    prefixFromNow: null,
    suffixAgo: 'առաջ',
    suffixFromNow: 'հետո',
    seconds: 'վայրկյաններ',
    minute: 'մեկ րոպե',
    minutes: '%d րոպե',
    hour: 'մեկ ժամ',
    hours: '%d ժամ',
    day: 'մեկ օր',
    days: '%d օր',
    month: 'մեկ ամիս',
    months: '%d ամիս',
    year: 'մեկ տարի',
    years: '%d տարի',
};
